// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"700":"7a7b70bb","899":"98527d58","964":"aa324a02"}[chunkId] + ".chunk.js");